import classnames from 'classnames'
import { CardSection } from '@components/CardSection'
import { CANADA_CURRENCY, DIGITAL_PASS_PRICE } from 'subscription-flow/constants'
import { RateCurrency } from 'shared/price-utilities'
import styles from 'subscription-flow/canada/components/styles.module.scss'

const DigitalAccessOption = ({ selectDeliveryRate, isSelected }) => (
    <CardSection
        activeSelected={isSelected}
        notActive
        className={classnames(styles.digitalAccessOptionCard, 'px-3', 'py-3', 'mt-3')}>
        <div className="d-sm-flex justify-content-between align-items-start" onClick={selectDeliveryRate}>
            <div>
                <div className="font-weight-bold text-large">
                    <T>subscription.purchase.accessOptions.digital.pass.label</T>
                </div>
                <div className="text-light">
                    <T>subscription.purchase.accessOptions.digital.pass.desc</T>
                </div>
            </div>
            <RateCurrency className="font-weight-bold" value={DIGITAL_PASS_PRICE} currency={CANADA_CURRENCY} />
        </div>
    </CardSection>
)

export default DigitalAccessOption
